import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Slider } from './ui/slider';
import { Alert, AlertDescription } from './ui/alert';
import { Sliders } from 'lucide-react';

export default function ScaleControl({ scale, onScaleChange, dimensions, printerLimits, materialType }) {
  if (!dimensions || !printerLimits) return null;

  const limits = printerLimits[materialType];
  // Guard against division by zero when a dimension is 0 (degenerate mesh)
  const maxScaleX = limits && dimensions.x > 0 ? limits.max_x / dimensions.x : 5;
  const maxScaleY = limits && dimensions.y > 0 ? limits.max_y / dimensions.y : 5;
  const maxScaleZ = limits && dimensions.z > 0 ? limits.max_z / dimensions.z : 5;
  const maxScale = Math.min(maxScaleX, maxScaleY, maxScaleZ, 5);

  const scaledDimensions = {
    x: dimensions.x * scale,
    y: dimensions.y * scale,
    z: dimensions.z * scale
  };

  const isWithinLimits = limits &&
    scaledDimensions.x <= limits.max_x &&
    scaledDimensions.y <= limits.max_y &&
    scaledDimensions.z <= limits.max_z;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Sliders className="w-5 h-5" />
          Größe anpassen
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="text-sm font-medium mb-2 block text-gray-900">
            Skalierung: {(scale * 100).toFixed(1)}%
          </label>
          <Slider
            value={[scale]}
            onValueChange={([value]) => onScaleChange(value)}
            max={maxScale}
            min={0.1}
            step={0.1}
            className="w-full"
          />
        </div>

        <div className="space-y-2">
          <h4 className="text-sm font-medium text-gray-900">Abmessungen (mm)</h4>
          <div className="grid grid-cols-3 gap-2">
            <div className="text-center">
              <p className="text-xs text-gray-500">Länge (X)</p>
              <p className="font-mono text-gray-900">{scaledDimensions.x.toFixed(1)}</p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">Breite (Y)</p>
              <p className="font-mono text-gray-900">{scaledDimensions.y.toFixed(1)}</p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">Höhe (Z)</p>
              <p className="font-mono text-gray-900">{scaledDimensions.z.toFixed(1)}</p>
            </div>
          </div>
        </div>

        {limits && (
          <div className="space-y-2">
            <h4 className="text-sm font-medium text-gray-900">Druckplattenlimits ({materialType})</h4>
            <div className="text-xs text-gray-600">
              Max: {limits.max_x} × {limits.max_y} × {limits.max_z} mm
            </div>
            {!isWithinLimits && (
              <Alert variant="destructive">
                <AlertDescription>
                  Das Modell überschreitet die Druckplattengrenzen!
                </AlertDescription>
              </Alert>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
